export default {
      id: "user-solid-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#user-solid-usage",
      toString: function () {
        return this.url;
      }
    }